export enum FixedTermStatus {
  EN_CURSO = '0',
  RECHAZADO = '2',
  DEBIN_SIN_AUTORIZAR = '99',
  ERROR_PLAZOFIJO = '100',
  PLAZOFIJO_CADUCADO = '101',
  CREDIN_EN_CURSO = '150',
  CREDIN_ACREDITADO = '151',
  DEBIN_VENCIDO = 'Debin Vencido',
  DEBIN_RECHAZADO = 'Debin Rechazado',
}

export interface IFixedTermItem {
  id: string;
  status?: FixedTermStatus;
  finalAmount?: number;
  amount?: number;
  interest?: number;
  tae?: number;
  tna?: number;
  createdDate?: string;
  expiredDate?: string;
  term?: number;
  mode?: string;
  certificate?: number;
  debinId?: string;
  expiredDateDebin?: string;
  uniformBankKey?: string;
  identifierId?: string;
}
